import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss'],
  standalone: false,
})
export class DownloadsComponent {
  @Output() close = new EventEmitter<void>();
  isFileAvailable: boolean = false;
  fileUrl: string = '';
  currentLink: string = '';
  qrCodeUrl: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DownloadsComponent>
  ) {
    this.fileUrl = data.fileUrl;
    this.currentLink = `${data.baseUrl}${data.slug}`;
  }

  ngOnInit() {
    this.isFileAvailable = !!this.fileUrl;
    this.generateQRCode(this.currentLink);
  }

  generateQRCode(link: string) {
    this.qrCodeUrl = `https://quickchart.io/qr?text=${encodeURIComponent(
      link
    )}&size=150&dark=0058DF&light=FFFFFF`;
  }

  downloadFile() {
    if (this.isFileAvailable && this.fileUrl) {
      // const link = document.createElement('a');
      // link.href = this.fileUrl;
      // link.download = 'prospectus.pdf';
      // link.click();
      window.open(this.fileUrl, '_blank');
    } else {
      alert('File is not available');
    }
  }

  downloadQrCode() {
    if (this.qrCodeUrl.startsWith('data:image')) {
      const link = document.createElement('a');
      link.href = this.qrCodeUrl;
      link.download = 'qr-code.png';
      link.click();
    } else {
      fetch(this.qrCodeUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'qr-code.png';
          link.click();
        })
        .catch((err) => console.error('Error downloading QR code:', err));
    }
  }

  closeModal() {
    this.close.emit();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
